import SgpDialog from './dialog.vue'

SgpDialog.install = function (Vue) {
  Vue.component(SgpDialog.name, SgpDialog)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(SgpDialog)
}

export default SgpDialog
